import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker } from './shared';

/**
 * DIFF LINE
 *
 * One change in an audit trail: a symbol in the margin, the field, and what
 * happened to its value. The call activity log draws the three kinds —
 * added, removed, changed — and each used to pick its own colour for the
 * symbol and its own weight for the field, in three copies of the same row.
 *
 * The symbol is the only thing here that varies by kind; the field and the
 * values are Text roles, chosen in the component.
 */
export const diffLineRecipe = cva([uiMarker, 'font-sans text-body-sm']);

/** The `+`, `−` or `~` in the margin. Fixed width so the lines align. */
export const diffSymbolRecipe = cva(
  [uiMarker, 'w-3 shrink-0 font-sans text-caption font-bold'],
  {
    variants: {
      kind: {
        add: 'text-success',
        remove: 'text-destructive',
        change: 'text-info',
      },
    },
    defaultVariants: { kind: 'change' },
  }
);

export type DiffSymbolRecipeProps = VariantProps<typeof diffSymbolRecipe>;
